import {createContext} from 'react';

interface SeriesContextProps {
    seriesSlug?: string;
    seriesIndex?: number;
}

export const SeriesContext = createContext<SeriesContextProps>({});
